/* eslint-disable jsx-a11y/label-has-associated-control */

import FeedbackForm from "components/support/FeedbackForm";
import { FormattedMessage } from "react-intl";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  InlineDialogClose,
} from "components/ui/Dialog";
import { MegaphoneIcon } from "lucide-react";
import { useState, type ReactNode } from "react";

interface FeedbackDialogProps {
  title: string | null;
  description?: ReactNode | null;
  children: ReactNode;
}

export default function FeedbackDialog({ title, description, children }: FeedbackDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Dialog modal={true} onOpenChange={setIsOpen} open={isOpen}>
      <DialogTrigger asChild={true}>{children}</DialogTrigger>
      <DialogContent
        hideCloseButton={true}
        className="mt-12 max-w-sm rounded-3xl bg-white dark:border-slate-900 dark:bg-slate-700 sm:mt-0 sm:rounded-3xl md:max-w-lg"
      >
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2 text-2xl font-black leading-6 dark:text-teal-400 lg:leading-7">
            <MegaphoneIcon />
            <FormattedMessage defaultMessage="Feedback" id="Ejhdi4" />
          </DialogTitle>
          <DialogDescription className="text-base font-medium text-slate-600 dark:text-slate-300">
            {description || (
              <FormattedMessage
                defaultMessage="Nos ajude a melhorar o Fundamentei. Compartilhe seu feedback."
                id="DXdBnl"
              />
            )}
          </DialogDescription>
        </DialogHeader>

        <InlineDialogClose className="absolute right-4 top-0" />

        <FeedbackForm defaultTitle={title} onSubmit={() => setIsOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
